import '.by{position:relative;}.ssr-plugin'
import '.i2{width:64px;}.ssr-plugin'
import '.i3{height:64px;}.ssr-plugin'
import '.bu{flex-shrink:0;}.ssr-plugin'
import '.w{position:absolute;}.ssr-plugin'
import '.i4{bottom:-4px;}.ssr-plugin'
import '.c5{right:-4px;}.ssr-plugin'
import '.dq{border-radius:50%;}.ssr-plugin'
import '.i5{border:2px solid var(--shades-white);}.ssr-plugin'
import '.a0{overflow:hidden;}.ssr-plugin'
import '.i6{width:32px;}.ssr-plugin'
import '.i7{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'

type ConversationAvatarProps = {
  initiativeImage?: string
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  return (
    <div className="by i2 i3 bu"
    >
      {initiativeImage ? (
        <Image
          src={initiativeImage}
          resizeWidth={128}
          alt="initiative"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="w i4 c5 dq i5 a0 i6 i7"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
